<template>
  <div id="app">
    <router-view />
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <!-- 屏幕宽度{{clientWidth}} -->
    <div v-if="!path.includes(this.$route.name)">
      <Float></Float>
    </div>
    <Rdialog
      :isIntegral="isIntegral"
      :integralText="integralText"
      @handleClose="handleClose"
    ></Rdialog>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import Float from "@/components/float/index.vue";
import Rdialog from "@/components/rdialog/index.vue";
import { UserInfo, AddPoints, ReadNotice, GetUserLogs, GetIndex } from "./api/index";
import { getCookie, setCookie } from './utils/_handleCookie'

export default {
  name: "App",
  components: {
    Float,
    Rdialog,
  },
  data() {
    return {
      isIntegral: false,
      integralText: "",
      path: ['ScanCode'],
      timer: null
    };
  },
  mounted() {
    this.$eventBus.$on('message', (data) => {
      clearInterval(this.timer)
    })
    ReadNotice().then((res) => {
      if (res.Status === 1) {
        if (res.Message) {
          this.isIntegral = true;
          this.integralText = res.Message;
        }
      }
    });
    const that = this;
    setTimeout(() => {
      if (!this.$route.query.track) {
        this.$route.query.track = "7756";
      }
      UserInfo(this.$route.query.track).then((res) => {
        // 增加埋点
        if(this.is_wx()){
          if(getCookie('GBOpenId')){
            extsma.bindUser('scrm', getCookie('GBOpenId'), getCookie('GBOpenId'));
          }else if(res.Data.OpenId){
            setCookie('GBOpenId', res.Data.OpenId)
            extsma.bindUser('scrm', res.Data.OpenId, res.Data.OpenId);
          }else {
            GetIndex(window.location.href).then(res => {
              window.location.href = res.Data
            })
          }
        }else{
          if(res.Data.OpenId){
            extsma.bindUser('scrm', res.Data.OpenId, res.Data.OpenId);
          }else{
            extsma.bindUser('scrm', getCookie('c__utma'), '');
          }
        }
        
        if (res.Status == 1) {
          this.$store.dispatch("userInfo", res.Data);
          this.$store.commit("islogin", true);

          this.timer = setInterval(() => {
            GetUserLogs({
              visitName: "页面访问-时长统计",
              visitType: 300,
              url: window.location.href,
              track: this.$route.query.track ? this.$route.query.track : 7756
            });
          }, 5000)
          
          AddPoints({
            visitType: 14,
            track: this.$route.query.track ? this.$route.query.track : "",
          }).then((res) => {
            if (res.Status === 1) {
              if (res.Data === "1") {
                this.isIntegral = true;
                this.integralText = res.Message;
              }
            }
          });
          // 已登录
          if (this.is_wx()) {
            dataLayer.push({
              open_id: res.Data.OpenId,
            });
          } else {
            // PC端
            dataLayer.push({
              event: "uprofile",
              open_id: res.Data.OpenId,
            });
          }
        } else {
          clearInterval(this.timer)
          this.$store.commit("islogin", false);
          // 未登录
          dataLayer.push({
            event: "uprofile",
            open_id: "visitor",
          });
        }
      });
      if (!this.$route.query.track) {
        this.$route.query.track = "7756";
      }
    }, 1000);
    this.$store.commit("load", true);
    setTimeout(() => {
      this.$store.commit("load", false);
      window.onscroll = () => {
        that.$store.commit(
          "scrollTop",
          document.documentElement.scrollTop || document.body.scrollTop
        );
      };
    }, 1000);

    window.onresize = () => {
      that.$store.commit("clientWidth", document.documentElement.clientWidth);
    };
  },
  methods: {
    is_wx() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    handleClose() {
      this.isIntegral = false;
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    fullPath() {
      return this.$route.fullPath;
    },
  },
  watch: {
    // // 监听小于768px后重载页面
    // clientWidth(news, olds) {
    //   if ((olds < 768 && news > 768) || (olds > 768 && news < 768)) {
    //     this.$toast.loading({ message: "loading", loadingType: "spinner" });
    //     setTimeout(() => {
    //       location.reload();
    //     }, 100);
    //   }
    // },
    fullPath() {
      this.$store.commit("load", true);
      setTimeout(() => {
        this.$store.commit("load", false);
      }, 500);
    },
  },
};
</script>

<style>
#app {
  overflow-x: hidden;
  font-family: Arial, "Microsoft YaHei";
}
</style>
